import React from 'react';
import CTA from "../../components/Constant/cta/CTA";
import WhySection from "../../components/WhySection/WhySection";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";

export default function OffshoreBankAccountOpening() {

    return (
        <main className='main'>
            <IntroSection
                title="Offshore Bank Account Opening"
                subtitle="Global Banking Solutions for Businesses and Entrepreneurs"
                description="Offshore Advisory assists international businesses, startups, and investors in opening offshore bank accounts and EMI/PSP accounts across more than 120 banks and payment institutions worldwide."
                badges={[
                    "Commercial, Private & Offshore Accounts",
                    "Crypto-Friendly EMI Accounts",
                    "Corporate Banking & Compliance Support"
                ]}
                buttonText="Request a Banking Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../assets/images/offshore-bank-account-opening/offshore-bank-account-opening.png')}
                imageAlt="Offshore Bank Account Opening"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Why Open an Offshore Bank Account?"
                        blocks={[
                            {
                                items: [
                                    { text: "🌍 Global Reach — transact in multiple currencies worldwide." },
                                    { text: "🔐 Confidentiality & Privacy — enhanced asset protection." },
                                    { text: "💳 Access to International Payment Systems — accept client payments globally." },
                                    { text: "⚖️ Compliance-Ready Structures — meet KYC/AML standards with proper guidance." },
                                    { text: "🚀 Flexibility — manage investments, business funds, or trading capital." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Types of Bank Accounts Available"
                        blocks={[
                            {
                                items: [
                                    {
                                        title: "Commercial Accounts",
                                        text: "For active businesses (import/export, consulting, e-commerce). Higher transaction volumes and compliance checks."
                                    },
                                    {
                                        title: "Private Banking Accounts",
                                        text: "For individuals managing personal assets and wealth. Tailored solutions including debit/credit cards, investments, and multi-currency accounts."
                                    },
                                    {
                                        title: "Offshore Retail Accounts",
                                        text: "For startups, small businesses, or individuals testing offshore structures. Lower costs, simple operations, entry-level banking."
                                    },
                                    {
                                        title: "EMI / PSP Accounts",
                                        text: "Electronic Money Institutions for fast, digital transactions. Ideal for fintechs, crypto companies, and global online businesses."
                                    }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Banking Jurisdictions We Cover"
                        blocks={[
                            {
                                items: [
                                    { text: "Europe — Cyprus, Malta, UK, Lithuania, Switzerland" },
                                    { text: "Africa — Mauritius, Seychelles, Western Sahara, Comoros" },
                                    { text: "Caribbean — St. Lucia, St. Vincent, Cayman Islands" },
                                    { text: "Asia — Singapore, Hong Kong, UAE" }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="How to Open an Offshore Bank Account"
                        blocks={[
                            {
                                items: [
                                    { text: "1. Consultation & Bank Selection — We analyze your business needs and match you with suitable banks/EMIs." },
                                    { text: "2. Document Preparation — Collect required KYC, corporate docs, and financial plans." },
                                    { text: "3. Application Submission — Submit your application and liaise with the bank." },
                                    { text: "4. Bank Due Diligence — Compliance checks, AML/KYC screening." },
                                    { text: "5. Approval & Account Activation — Account setup, online banking access, and payment integration." },
                                    { text: "⏱️ Timeline: 1–4 weeks depending on the bank and business activity." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Documents Typically Required"
                        blocks={[
                            {
                                items: [
                                    { text: "Apostilled company incorporation documents" },
                                    { text: "Passports + proof of address of shareholders/directors" },
                                    { text: "Company business plan & activity description" },
                                    { text: "Corporate structure chart (if applicable)" },
                                    { text: "Compliance/KYC policies (we prepare these if needed)" }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="EMI / PSP Account Benefits"
                        blocks={[
                            {
                                items: [
                                    { text: "⚡ Faster international transactions" },
                                    { text: "🔐 Enhanced data protection & fraud prevention" },
                                    { text: "💻 Remote account access anytime, anywhere" },
                                    { text: "💳 Multi-currency and crypto-friendly payment options" },
                                    { text: "💼 Lower transaction & maintenance fees" }
                                ]
                            }
                        ]}
                    />

                    <DetailsSection title='Why Choose offshore Advisory'
                                    items={
                                        [
                                            { text: "Network of 120+ banks and EMIs worldwide" },
                                            { text: "Specialized in high-risk industries (crypto, gaming, forex, fintech)" },
                                            { text: "End-to-end support: documents, compliance, and negotiations" },
                                            { text: "Confidential & efficient process" }
                                        ]
                                    }
                    />


                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Need an offshore or EMI bank account?"
                        description="Our experts will help you find the right bank, prepare documents, and guide you through compliance."
                        buttonText="Book a Free Banking Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};
const faqData = [
    {
        question: "Can I open an offshore bank account remotely?",
        answer: "Yes, most banks and EMIs allow remote applications. Some may require a video KYC call.",
    },
    {
        question: "How much money do I need to deposit?",
        answer: "It depends on the bank. Some require as little as USD 1,000; others may require higher deposits for private banking.",
    },
    {
        question: "Can crypto businesses open offshore bank accounts?",
        answer: "Yes — we work with crypto-friendly banks and EMIs.",
    },
    {
        question: "How long does the process take?",
        answer: "Typically 1–4 weeks, depending on jurisdiction and compliance checks.",
    },
    {
        question: "Do you guarantee account approval?",
        answer: "We do not guarantee approvals, but our expertise maximizes your chances by matching you with banks that accept your business profile.",
    },
];

const testimonialsData = [
    {
        quote: "Offshore Advisory helped us open a corporate account in less than 2 weeks. The process was smooth and professional.",
        author: "David M.",
        role: "Forex Broker"
    },
    {
        quote: "As a crypto startup, banking was a challenge. Offshore Advisory connected us with a crypto-friendly EMI and solved our problem.",
        author: "Lina K.",
        role: "FinTech Founder"
    }
];
